import React from 'react'
import Dropdown from './Dropdown'
import { hourFields, minuteFields } from './DropdownValues'

export default class BirthTime extends React.Component {

	render() {
		const { birthHour, birthMinute, pm, onSelectChange, property } = this.props
		const hourOptions = hourFields()
		const minuteOptions = minuteFields()
		return (
			<div className='capps-dropdown'>
				<Dropdown
					name='birthHour'
					onSelectChange={onSelectChange}
					options={hourOptions}
					property={property}
					value={birthHour}
				/>
				<div className='capps-dropdown-text'>:</div>
				<Dropdown
					name='birthMinute'
					onSelectChange={onSelectChange}
					options={minuteOptions}
					property={property}
					value={birthMinute}
				/>
				<Dropdown
					name='birthAmPm'
					onSelectChange={onSelectChange}
					options={[{ label: 'am', value: false }, { label: 'pm', value: true }]}
					property={property}
					value={pm}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/Components/Display/BirthTime.js